import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=50af5871&scoped=true&"
import script from "./CompanyList.vue?vue&type=script&lang=ts&"
export * from "./CompanyList.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CompanyList.vue?vue&type=style&index=1&id=50af5871&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50af5871",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VContainer,VDataTable,VFlex,VIcon,VLayout})
